import PrivacyPolicy from "./PrivacyPolicy";

// Terms & Conditions share the same content as Privacy Policy per clinic policy.
const TermsConditions = () => <PrivacyPolicy />;

export default TermsConditions;
